var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoV3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#007F7C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.859,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00739 6.01343C8.24409 6.01343 8.48078 6.01343 8.71747 6.01343C8.73724 9.21556 8.71747 12.4173 8.6583 15.6189C8.46102 16.0347 8.26381 16.4506 8.06657 16.8664C8.00739 13.249 7.98768 9.63134 8.00739 6.01343Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.06991 6.01358C9.34116 5.98165 9.59762 6.02319 9.83917 6.13833C9.9181 8.59173 9.9181 11.045 9.83917 13.4984C9.57312 13.8512 9.33643 14.2254 9.12909 14.6211C9.06991 11.7522 9.05015 8.88301 9.06991 6.01358Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.727,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1441 6.01358C10.4154 5.98165 10.6718 6.02319 10.9134 6.13833C10.9923 7.88479 10.9923 9.63124 10.9134 11.3777C10.6473 11.7305 10.4106 12.1047 10.2033 12.5004C10.1441 10.3386 10.1244 8.17632 10.1441 6.01358Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.752,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0435 6.01407C14.3098 5.97427 14.5465 6.03665 14.7536 6.20119C12.7162 10.0592 10.7241 13.9472 8.77706 17.865C8.53552 17.9802 8.27912 18.0217 8.00781 17.9898C9.89532 13.9275 11.9072 9.93561 14.0435 6.01407Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.761,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9798 6.01361C15.2843 5.9697 15.5604 6.03207 15.8082 6.20073C13.7709 10.0588 11.7788 13.9468 9.83175 17.8646C9.57861 18.0229 9.32227 18.0229 9.0625 17.8646C11.0681 13.9273 13.0406 9.97694 14.9798 6.01361Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1712 6.01361C16.4757 5.9697 16.7518 6.03207 16.9997 6.20073C14.9623 10.0588 12.9702 13.9468 11.0232 17.8646C10.7816 17.9797 10.5252 18.0213 10.2539 17.9893C10.2841 17.6755 10.3828 17.3843 10.5498 17.1161C12.4853 13.4515 14.3591 9.75065 16.1712 6.01361Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.722,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1552 12.5005C15.1287 14.2607 16.0755 16.0487 16.9955 17.8646C16.6956 18.0239 16.3997 18.0239 16.1079 17.8646C15.3584 16.3676 14.6088 14.8707 13.8593 13.3737C13.8218 13.036 13.9204 12.745 14.1552 12.5005Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.734,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5706 13.6233C13.7345 13.7573 13.8725 13.9236 13.9848 14.1223C14.6201 15.3543 15.2315 16.6017 15.8191 17.8647C15.5918 18.007 15.3551 18.0279 15.1091 17.9271C14.5221 16.8352 13.95 15.7331 13.393 14.6213C13.3081 14.2586 13.3672 13.9259 13.5706 13.6233Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.714,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9845 14.7458C13.2133 14.8883 13.3908 15.0961 13.5171 15.3696C13.9011 16.2209 14.3154 17.0525 14.7597 17.8645C14.4836 18.0308 14.2074 18.0308 13.9313 17.8645C13.5867 17.0963 13.2119 16.3479 12.807 15.6191C12.735 15.2991 12.7941 15.0079 12.9845 14.7458Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoV3);
export default __webpack_public_path__ + "static/media/logoV3.448e049518b789ffbae0fd96a7a335fa.svg";
export { ForwardRef as ReactComponent };